import { getI18n } from '@/helpers/i18n';
import AdminIndex from '@/views/AdminRoot.vue';
import AdminUsers from '@/views/AdminUsers.vue';
import AdminUserEdit from '@/views/AdminUserEdit.vue';
import AdminStellen from '@/views/AdminStellen.vue';
import AdminStelleEdit from '@/views/AdminStelleEdit.vue';
import AdminConnectivity from '@/views/AdminConnectivity.vue';

export default [
    {
        path: '/admin',
        name: 'admin',
        component: AdminIndex,
        meta: {
            requiresAuth: true,
            title: () => getI18n().t('admin'),
            breadcrumbTitle: () => getI18n().t('admin'),
            breadcrumbTo: { name: 'admin-users' }
        },
        children: [
            {
                path: 'users',
                meta: {
                    requiresAuth: true,
                    title: () => getI18n().t('users'),
                    skipBreadcrumb: true
                },
                children: [
                    {
                        path: '',
                        name: 'admin-users',
                        component: AdminUsers,
                        meta: {
                            requiresAuth: true,
                            title: () => getI18n().t('users'),
                            skipBreadcrumb: true
                        }
                    },
                    {
                        name: 'admin-users-edit',
                        path: ':id(\\d+)',
                        component: AdminUserEdit,
                        meta: {
                            requiresAuth: true,
                            title: () => getI18n().t('users'),
                            breadcrumbTitle: () => getI18n().t('edit')
                        }
                    }
                ]
            },
            {
                path: 'stellen',
                meta: {
                    requiresAuth: true,
                    title: () => getI18n().t('stellen'),
                    skipBreadcrumb: true
                },
                children: [
                    {
                        path: '',
                        name: 'admin-stellen',
                        component: AdminStellen,
                        meta: {
                            requiresAuth: true,
                            title: () => getI18n().t('stellen'),
                            skipBreadcrumb: true
                        }
                    },
                    {
                        name: 'admin-stelle-edit',
                        path: ':id(\\d+)',
                        component: AdminStelleEdit,
                        meta: {
                            requiresAuth: true,
                            title: () => getI18n().t('stellen'),
                            breadcrumbTitle: () => getI18n().t('stellen')
                        }
                    }
                ]
            },
            {
                path: 'connectivity',
                name: 'admin-connectivity',
                component: AdminConnectivity,
                meta: {
                    requiresAuth: true,
                    title: () => getI18n().t('connectivity'),
                    skipBreadcrumb: true
                }
            }
        ]
    }
];
